import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import PageHeader from "../PageHeader";
import PageSizeOptions from "../PageSizeOptions";
import AddSubcontractor from "./AddSubcontractor";
import http from "../../services/HttpService";
import config from "../../config.json";
import Moment from "react-moment";
import ActiveDeactiveHistory from "../SystemAdministration/ManagePartner/ActiveDeactiveHistory";
import { paginate, calculateIndex } from "../../utlis/paginate";
import ReminderAlertMessage from "../ReminderAlertMessage";
import Swal from "sweetalert2";
import Pagination from "../../comman/pagination";
import authService from "../../services/authService";
import TableLoader from "../../comman/TableLoader";
import {
  loadSubcontractors, getAllSubcontractors,
  getFilterAllSubcontractors,
  loadSubcontractorsByFilter, SendReminder, getReminderStatus,
  loadSubcontractorBprmForm,
  getSubcontractorBprmForm,
  filterAllSubcontractorStatus,
  getSubcontractorFilter,
  subsCurrentWfTaskReceived,
  receivedSubcontractorById
} from "../../app/store/subcontractor";
import { getCurrentUser } from "../../app/store/auth";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { Tab, Tabs } from "react-bootstrap";
import { getFormatedNumber } from "../../services/appService";
import { getAlert } from "../../services/appAlerts";
import Document from "../PortalForms/Document";
import WorkflowElement from "../../app/components/WorkflowElement";
import { documentReceived, esignDocumentsReceived, reqDocumentReceived } from "../../app/store/documents";
import { recCurrentWfTaskReceived, receivedRecruiterById } from "../../app/store/recruiter";
import { formLibraryReceived } from "../../app/store/forms";
import AchInformation from "../../ReviewTools/AchInformation";
import InsuranseInformation from "../../ReviewTools/InsuranseInformation";
import { candidateAppsReceived, receivedCandidateById } from "../../app/store/candidate";
import { getSubcontractorPartners, loadSubcontractorPartners } from "../../app/store/partner";

export default function ListSubcontractor() {

  let route = [{ name: "Onboarding and Contracts", url: "" }];

  const param = useParams();
  const type = param?.type;

  if (type === "partner") {
    route = [
      { name: "System Administration", url: "" },
      { name: "Manage Entities", url: "" },
    ];
  } else {
    route = [
      { name: "Onboarding and Contracts", url: "" },
    ];
  }

  const currentUser = getCurrentUser();

  const [partnerType, setPartnerType] = useState("Sub-Contractors");
  const [actionType, setActionType] = useState("action");
  const [subcontractors, setSubcontractors] = useState([]);
  const [rowsCount, setRowsCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);

  const [showHide, setShowHide] = useState(false);
  const [logShowHide, setLogShowHide] = useState(false);
  const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);

  const [selectedObj, setSelectedObj] = useState(null);
  const [subId, setSubId] = useState("");
  const [subcontractorId, setSubcontractorId] = useState("");
  const [subName, setSubName] = useState("");
  const [subEmail, setSubEmail] = useState("");
  const [dataType, setDataType] = useState("");
  const [selectedSubcontractorId, setSelectedSubcontractorId] = useState(0);
  const [selectedTab, setSelectedTab] = useState("home");

  const [viewRowType, setViewRowType] = useState("");
  const [selectedFormKey, setSelectedFormKey] = useState(-1);
  const [selectedKey, setSelectedKey] = useState(-1);
  const [appDocuments, setAppDocuments] = useState([]);
  const [selectedCurrentTask, setSelectedCurrentTask] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [viewFormType, setViewFormType] = useState("");

  const [achType, setAchType] = useState("");
  const [insuranceType, setInsuranceType] = useState("");
  const [selectedInfo, setSelectedInfo] = useState("");
  const [editDurType, setEditDurType] = useState("");
  const [fetchedDataType, setFetchedDataType] = useState("");
  const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);

  const [filterShowHide, setFilterShowHide] = useState(false);
  const [filterSubcontractorList, setFilterSubcontractorList] = useState([]);

  const allSubcontractors = useSelector(getAllSubcontractors);
  const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);
  const remiderStatus = useSelector(getReminderStatus);
  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  const subcontractorFilterdata = useSelector(getSubcontractorFilter);

  const subcontractorPartnersSelector = useSelector(getSubcontractorPartners);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentRoute(route));
    dispatch(setCurrentPageTitle("Subcontractors"));
    dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor))
  }, [])

  useEffect(() => {
    if (subcontractorFilterdata === "" && selectedTab === "home") {
      dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
    } else if (subcontractorFilterdata.dataType === "filter") {
      setSubId(subcontractorFilterdata.id);
      setSubName(subcontractorFilterdata.name);
      setSubEmail(subcontractorFilterdata.entity);
    }
  }, [selectedTab]);

  useEffect(() => {
    if (allSubcontractors.length > 0) {
      if (allSubcontractors.length > 0)
        setRowsCount(allSubcontractors[0].totalPartners);
      setSubcontractors(allSubcontractors);
      handleCloseDocumentView();
    }
  }, [allSubcontractors]);

  useEffect(() => {
    if (subcontractorBprmFormSelector) setWfForm(subcontractorBprmFormSelector);
  }, [subcontractorBprmFormSelector])

  useEffect(() => {
    setCurrentPage(1);
    setPageSize(5);
    getPagedData(filterAllSubcontractors, 1, 5);
  }, [filterAllSubcontractors]);

  useEffect(() => {
    if (remiderStatus === "success") {
      getAlert("", "Reminder Sent Successfully", "success");
      if (dataType === "filter")
        getPagedData(filterAllSubcontractors, currentPage, pageSize);
      else
        dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
    }
  }, [remiderStatus])

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    if (dataType === "filter")
      getPagedData(filterAllSubcontractors, page, pageSize)
    else
      dispatch(loadSubcontractors(pageSize, page, partnerType));
  };


  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    if (dataType === "filter")
      getPagedData(filterAllSubcontractors, currentPage, currentTarget.value);
    else
      dispatch(loadSubcontractors(currentTarget.value, currentPage, partnerType));
  };

  useEffect(() => {
    setFilterSubcontractorList(subcontractorPartnersSelector);
  }, [subcontractorPartnersSelector])

  const handleModalShowHide = () => {
    //const obj = subcontractors.filter(x => x.fuid === selectedSubcontractorId);
    //if (obj.length > 0)
    // setSelectedObj(obj[0])
  };


  const handleLogShowHide = (item, actionType) => {
    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType(actionType);
      if (dataType === "filter")
        getPagedData(filterAllSubcontractors, currentPage, pageSize);
      else
        dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(actionType);
    }
  };

  const handleFilter = () => {
    setDataType("filter");

    var frmBody = new FormData();
    frmBody.append("id", !subId ? "" : subId);

    if (subcontractorId && !subId)
      frmBody.append("id", subcontractorId);

    frmBody.append("name", !subName ? "" : subName);
    frmBody.append("email", !subEmail ? "" : subEmail);
    frmBody.append("type", !partnerType ? "" : partnerType);
    dispatch(loadSubcontractorsByFilter(frmBody));
    dispatch(filterAllSubcontractorStatus({
      "id": subId,
      "name": subName,
      "email": subEmail,
      "dataType": "filter",
    }));
  };

  const handleFilterCancel = (type) => {
    if (type === "close" && filterShowHide)
      setFilterShowHide(false);
    setDataType("");
    setSubId("");
    setSubcontractorId("");
    setSubName("");
    setSubEmail("");
    setCurrentPage(1);
    setPageSize(5);
    dispatch(loadSubcontractors(5, 1, partnerType));
    dispatch(filterAllSubcontractorStatus(""))

  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    if (items.length > 0)
      setRowsCount(items[0].totalPartners);

    setSubcontractors(items);
    handleCloseDocumentView();
  };

  const handleRemainder = async (id) => {
    dispatch(SendReminder(id));
  };

  const handleRemainderMessage = () => {
    setRemainderMsgShowHide(!remainderMsgShowHide);
  };

  const handlePartnerPerformer = () => {
    if (selectedSubcontractorId > 0)
      navigate("/ManagePartnerPerformer", {
        state: {
          obj: selectedObj,
          partner: "Subcontractors",
          url: "ListSubcontractor/partner",
        }
      })
  }

  const getLastWorkflowTask = (workflowTasks) => {
    console.log("Workflow Tasks: ", workflowTasks);
    const allTasks = workflowTasks.filter(
      (x) =>
        x.itemType === 1 &&
        x.applicantId !== x.performerId &&
        x.taskDoneStatus > 0
    );
    if (allTasks.length === 0) {
      return workflowTasks[workflowTasks.length - 1];
    }
    const tsk = allTasks[allTasks.length - 1];
    return tsk;
  };

  const handlePartnerApplication = (item, app) => {
    // navigate("/CustomerApps", {
    //   state: {
    //     item: item,
    //     currentUser: currentUser,
    //     type: type,
    //     selectedApp: app.applicationId,
    //     appType: "partner",
    //     module: "Subcontractor",
    //   }
    // })
    navigate("/ReviewTask", {
      state: {
        task: getLastWorkflowTask(app.workflowTasks),
        item,
        app,
        type: type,
        parentApplication: null,
        appType: "partner",
        module: "Subcontractor",
      }
    })
  }
  const handleSelectSubcontrator = (item) => {
    setSelectedSubcontractorId(item.fuid)
    setSelectedObj(item);
  }

  const handleResetSelection = () => {
    setSelectedSubcontractorId(0);
    setSelectedObj(null);
  }

  const handlePermissionShowHide2 = () => {
    dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
    setSelectedTab("home")
  };

  const handleAddEditSubcontractor = (data) => {
    if (data === "exit") {
      if (dataType === "filter")
        getPagedData(filterAllSubcontractors, currentPage, pageSize);
      else
        dispatch(loadSubcontractors(pageSize, currentPage, partnerType));

      setSelectedTab("home");
      setSelectedObj(null);
      setSelectedSubcontractorId(0);
    }
  }

  const handleTabOnSelect = (tab) => {
    setSelectedTab(tab)
  }

  const handleDocumentViewShowHide = (type, key, app) => {
    if (viewRowType === type) return;
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    if (!tsk) {
      setTimeout(() => {
        handleCloseDocumentView();
        setSelectedCurrentTask(tsk);
        setViewRowType(type);
        setSelectedInfo(type);
        setSelectedKey(key);
        setSelectedApp(app);
      }, 1000);
    }
    else {
      handleCloseDocumentView();
      setSelectedCurrentTask(tsk);
      setViewRowType(type);
      setSelectedInfo(type);
      setSelectedKey(key);
      setSelectedApp(app);
    }
  };

  const handleCloseDocumentView = () => {
    console.log("candidatelist")
    setSelectedCurrentTask(null);
    setSelectedFormKey(-1);
    setViewFormType("");
    setUpdatedStateData("");
    setSelectedKey(-1);
    setViewRowType("");
    setSelectedApp(null);
    dispatch(documentReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(formLibraryReceived([]));
    dispatch(reqDocumentReceived([]));
    dispatch(esignDocumentsReceived([]));
    dispatch(candidateAppsReceived([]))
  }

  const handleNextTask = () => {
    console.log("")
  }

  const handleViewSubcontractorForm = (type, key, item) => {
    setSelectedKey(-1)
    setViewRowType("");
    setSelectedApp(null);
    setSelectedCurrentTask(null);
    if (viewFormType === type) {
      setViewFormType("");
      setSelectedFormKey(-1);
      setUpdatedStateData()
    } else {
      setViewFormType(type);
      setSelectedFormKey(key);
      if (item.applications?.length > 0)
        setUpdatedStateData(item.applications[0].applicationData);
      else
        setUpdatedStateData(item.contact1.performerData);
    }
  }

  const handleACHShowHide = (mod, type, item, key, app) => {
    console.log("candidatelist")
    if (achType == type) return;
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    dispatch(receivedRecruiterById([]));
    setSelectedInfo(mod);
    setSelectedKey(key);
    setFetchedDataType("")
    setEditDurType("");
    setAchType(type);
    setInsuranceType("");
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);

  }

  const handleInsuranceShowHide = (mod, type, item, key, app) => {
    console.log("candidatelist")
    if (insuranceType == type) return;
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    dispatch(receivedRecruiterById([]));
    setSelectedInfo(mod);
    setSelectedKey(key);
    setFetchedDataType("")
    setEditDurType("");
    setAchType("");
    setInsuranceType(type);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  }

  const closeACHInsu = () => {
    setSelectedInfo("");
    setSelectedKey(-1);
    setAchType("");
    setInsuranceType("");
  }

  const handleSearchShowHide = () => {
    setFilterShowHide(!filterShowHide);
    setSubcontractorId("");
    setSubId("");
    setSubName("");
    setSubEmail("");
    if (!filterShowHide) {
      if (subcontractorPartnersSelector.length === 0)
        dispatch(loadSubcontractorPartners("Sub-Contractors"));
    }
  }

  return (
    <React.Fragment>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none">
          <div className="card-header border-0 p-2">
            <div className="row">
              <div className="col-md-10">
                <PageSizeOptions
                  pageSize={pageSize}
                  onChange={handlePageSizeChanged}
                ></PageSizeOptions>
              </div>
              <div className="col-md-2 text-right">
                <button
                  className="btn btn-sm btn-outline-default btn-min-width"
                  //data-toggle="collapse"
                  //data-target="#collapseExample"
                  onClick={handleSearchShowHide}
                >
                  <i className="fa fa-search" aria-hidden="true"></i> Search
                </button>
                {/* {type === "application" && (
                  <button
                    className="btn btn-outline-default btn-sm mr-2"
                    onClick={() => handleModalShowHide("")}
                  >
                    Add Subcontractor
                  </button>
                )} */}
              </div>
              {filterShowHide &&
                <div className="col-md-12">
                  <div className="p-2 bg-secondary border mt-2" id="collapseExample">
                    <div className="row">
                      <div className="col-md-2">
                        <div className="form-group">
                          <label
                            htmlFor="subId"
                            className="form-control-label"
                          >
                            ID
                          </label>
                          <input
                            type="text"
                            name="subId"
                            aria-label="Email Input"
                            id="subId"
                            className="form-control"
                            placeholder="ID"
                            value={subId}
                            onChange={({ currentTarget }) => setSubId(currentTarget.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-5">
                        {/* <div className="form-group">
                        <label
                          htmlFor="subName"
                          className="form-control-label"
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          name="subName"
                          id="subName"
                          className="form-control"
                          aria-label="Email Input"
                          placeholder="Name"
                          value={subName}
                          onChange={({ currentTarget }) => setSubName(currentTarget.value)}
                        />
                      </div> */}
                        <div className="form-group">
                          <label
                            htmlFor="subcontractorId"
                            className="form-control-label"
                          >
                            Subcontractor
                          </label>
                          <select
                            name="subcontractorId"
                            id="subcontractorId"
                            className="form-control"
                            onChange={({ currentTarget }) => setSubcontractorId(currentTarget.value)}
                            value={subcontractorId}
                          >
                            <option value="">Select</option>
                            {filterSubcontractorList?.map((item) => (
                              <option value={item.fuid}>{item.label} - {item.fuid}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="form-group">
                          <label
                            htmlFor="subEmail"
                            className="form-control-label"
                          >
                            Email
                          </label>
                          <input
                            type="text"
                            name="subEmail"
                            id="subEmail"
                            className="form-control"
                            aria-label="Email Input"
                            placeholder="Email"
                            value={subEmail}
                            onChange={({ currentTarget }) => setSubEmail(currentTarget.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 text-center ">
                        <button
                          className="btn-sm btn-outline-default mr-2"
                          onClick={() => handleFilter()}
                        >
                          <i className="fa fa-search mr-2" aria-hidden="true"></i>Search
                        </button>
                        <button
                          className="btn-sm btn-outline-default mr-2"
                          onClick={() => handleFilterCancel("refresh")}
                        >
                          <i className="fa fa-refresh mr-2" aria-hidden="true"></i>Refresh
                        </button>
                        <button
                          className="btn-sm btn-outline-default mr-2"
                          //data-toggle="collapse"
                          //data-target="#collapseExample"
                          onClick={() => handleFilterCancel("close")}
                        >
                          <i className="fa fa-close mr-2" aria-hidden="true"></i>Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>
          </div>
          <div className="card-body p-2">
            <Tabs
              activeKey={selectedTab}
              onSelect={handleTabOnSelect}
              id="uncontrolled-tab-example"
              className="h3 border border-right-0 border-left-0 border-top-0 font-weight-normal"
            >
              <Tab eventKey="home" title="Subcontractors"
                tabClassName="page-tab border border-left-0 border-top-0">
                <Tab.Content className="border border-top-0">
                  <div className="table-responsive">
                    {/* <button className="btn btn-sm btn-link" onClick={handleResetSelection}>Reset Selection</button> */}
                    <table className="table align-items-center table-flush table-hover ">
                      <thead className="thead-light">
                        <tr>
                          <th>Select
                            <span style={{ cursor: "pointer" }} onClick={handleResetSelection}>
                              <i className="fa fa-refresh ml-2 text-primary" aria-hidden="true"></i>
                            </span>
                          </th>
                          <th>ID</th>
                          <th>Subcontractor</th>
                          <th>ENROLLMENT</th>
                          {type !== "partner" && <th>Key Contact</th>}
                          <th>Enrollment Status</th>
                          {type === "partner" && <><th>Total User</th><th>Status</th></>}
                        </tr>
                      </thead>
                      <tbody>
                        {subcontractors.map((item, key) => (
                          <>
                            <tr className={`${(selectedKey !== key && selectedKey !== -1) || (selectedFormKey !== key && selectedFormKey !== -1) ? "d-none" : ""}`}>
                              <td>
                                <div className="custom-control custom-radio">
                                  <input
                                    className="custom-control-input"
                                    type="radio"
                                    id={item.fuid}
                                    name="subcontractor"
                                    aria-label="Select Subcontractor"
                                    onChange={() => handleSelectSubcontrator(item)}
                                    value={selectedSubcontractorId}
                                    checked={selectedSubcontractorId === item.fuid}
                                  />
                                  <label
                                    className="custom-control-label"
                                    aria-label="Select Subcontractor"
                                    htmlFor={item.fuid}
                                  >
                                  </label>
                                </div>
                              </td>
                              <td>
                                {item.fuid}
                              </td>
                              <td>
                                <button
                                  onClick={() => handleViewSubcontractorForm("Subcontractor", key, item)}
                                  className="btn p-0 btn-link btn-sm text-uppercase">
                                  {item.label}
                                </button>
                                <br />
                                <span>{type === "application" ? item?.email : item?.contact1?.performeremail}</span>
                                <br />
                                <Moment format="MMM Do YYYY h:mm a">
                                  {item.createdDate}
                                </Moment>
                              </td>

                              <td className="pb-0">
                                <div className="border p-0">
                                  {item.applications.map((app) => (
                                    <div key={app.applicationId} className="mb-2 text-center">
                                      <span className="text-dark">
                                        {app.applicationId} - {app.applicationType}
                                      </span>

                                      <div className="mt-1">
                                        {type === "application" ? (
                                          <>
                                            {app.appSubmitted ? (
                                              <button
                                                onClick={() => handlePartnerApplication(item, app)}
                                                style={{ border: "none" }}
                                                className="badge badge-success rounded-0 btn-min-width"
                                              >
                                                Complete
                                              </button>
                                            ) : (
                                              <button
                                                onClick={() => handlePartnerApplication(item, app)}
                                                style={{ border: "none" }}
                                                className="badge badge-success rounded-0 bg-yellow btn-min-width"
                                              >
                                                Review
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {app.appSubmitted ? (
                                              <button
                                                style={{ border: "none" }}
                                                className="badge badge-success rounded-0 btn-min-width"
                                              >
                                                Complete
                                              </button>
                                            ) : (
                                              <button
                                                style={{ border: "none" }}
                                                className="badge badge-success rounded-0 bg-yellow btn-min-width"
                                              >
                                                Review
                                              </button>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </td>


                              {type !== "partner" && (
                                <td>
                                  {item.contact1 !== null && (
                                    <React.Fragment>
                                      <span className="text-uppercase">
                                        {item.contact1.performername}{" "}
                                        {item.contact1.lastName}
                                      </span>
                                      <br />
                                      <span>
                                        {item.contact1.performeremail}
                                      </span>
                                      <br />
                                      {item.contact1?.contactNo && getFormatedNumber(item.contact1.contactNo)}
                                    </React.Fragment>
                                  )}
                                </td>
                              )}
                              <td>
                                {item.enrollmentStatus && "Complete"}
                                {!item.enrollmentStatus && "Pending"}
                                <br />
                                {item.contact1 !== null && type === "partner" && !item.enrollmentStatus && (
                                  <React.Fragment>
                                    <button
                                      className="btn btn-sm btn-link p-0"
                                      onClick={() =>
                                        handleRemainder(
                                          item.contact1.performerid
                                        )
                                      }
                                    >
                                      Send Reminder
                                    </button>{" "}
                                    <button
                                      className="btn btn-sm btn-link p-0 mt-1"
                                      title="View message"
                                      onClick={handleRemainderMessage}
                                    >
                                      <span className="badge badge-warning rounded-0 text-red"
                                        style={{ minWidth: "70px", fontSize: "12px" }}>
                                        <i
                                          class="fa fa-envelope mr-1"
                                          aria-hidden="true"
                                        ></i>
                                        {!item.contact1?.msgAlertCount ? 0
                                          : item.contact1.msgAlertCount}
                                      </span>
                                    </button>
                                  </React.Fragment>
                                )}
                              </td>
                              {type === "partner" && (
                                <>
                                  <td>
                                    {item.activeUsers}
                                  </td>
                                  <td>
                                    {item.contact1?.isActive === true && (
                                      <span>
                                        <i
                                          className="fa fa-check text-success"
                                          style={{ fontSize: "15px" }}
                                          aria-hidden="true"
                                        ></i>{" "}
                                        Activated
                                        {item.contact1.addedDateTime && (
                                          <>
                                            <br />
                                            <Moment format="MMM Do YYYY, h:mm a">
                                              {item.contact1.addedDateTime}
                                            </Moment>
                                          </>
                                        )}
                                        <br />
                                      </span>
                                    )}
                                    {item.contact1?.isActive === false && (
                                      <span>
                                        <i
                                          className="fa fa-times text-danger"
                                          style={{ fontSize: "15px" }}
                                          aria-hidden="true"
                                        ></i>{" "}
                                        Deactivated
                                        {item.contact1.addedDateTime && (
                                          <>
                                            <br />
                                            <Moment format="MMM Do YYYY, h:mm a">
                                              {item.contact1.addedDateTime}
                                            </Moment>
                                          </>
                                        )}
                                        <br />
                                      </span>
                                    )}
                                    {item.contact1?.isActive === null ? (
                                      <span>
                                        To Activate
                                        {item.contact1.addedDateTime && (
                                          <>
                                            <br />
                                            <Moment format="MMM Do YYYY, h:mm a">
                                              {item.contact1.addedDateTime}
                                            </Moment>
                                          </>
                                        )}
                                      </span>
                                    ) : <button
                                      className="btn btn-sm btn-link p-0"
                                      onClick={() =>
                                        handleRemainder(
                                          item.contact1.performerid
                                        )
                                      }
                                    >
                                      Resend
                                    </button>}
                                  </td>
                                </>
                              )}


                            </tr>
                            <tr className={`${(selectedKey !== key && selectedKey !== -1) || (selectedFormKey !== key && selectedFormKey !== -1) ? "d-none" : ""} text-white`}>
                              {item.applications.map((app) => (
                                <React.Fragment key={app.applicationId}>
                                  <td colSpan={2} className="border-0 pt-0 pb-0"></td>
                                  <td colSpan={1} className="border-0 pt-0 pb-0" >
                                    <>
                                      {type === "application" && <tr>
                                        <td className="text-left pt-0 pl-0 border-0">
                                          <button
                                            onClick={() => handleDocumentViewShowHide("Document", key, app)}
                                            className="btn btn-sm btn-link p-0"
                                            title="Contract Documents"
                                          >
                                            Send Contract Documents
                                          </button>
                                          <br />
                                          <button
                                            onClick={() => handleACHShowHide("ACH", "Subcontractor", item, key, app)}
                                            className="btn btn-sm btn-link p-0"
                                            title="Contract Documents"
                                          >
                                            ACH Information <span className="badge badge-pill badge-danger">{app?.achRequest}</span>
                                          </button>
                                          <br />
                                          <button
                                            onClick={() => handleInsuranceShowHide("Insurance", "Subcontractor", item, key, app)}
                                            className="btn btn-sm btn-link p-0"
                                            title="Contract Documents"
                                          >
                                            Insurance Information <span className="badge badge-pill badge-danger">{app?.insuranceRequest}</span>
                                          </button>
                                        </td>

                                      </tr>}
                                    </>
                                  </td>
                                  <td colSpan={4} className="border-0 pt-0 pb-0"></td>
                                </React.Fragment>
                              ))}
                            </tr>
                            <tr className={`${selectedKey === key ? "" : "d-none"}`}>
                              {selectedInfo === "Document" && selectedKey === key &&
                                <td colSpan={7} className="bg-white p-3">
                                  <div className="text-left mb-3 pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => handleCloseDocumentView("Document", -1, null)}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                  </div>
                                  <Document
                                    documents={appDocuments}
                                    workflowTask={selectedCurrentTask}
                                    uploadType={"Subcontractor"}
                                    app={selectedApp}
                                    item={item}
                                    prevItem={subcontractors.length - 1 !== key && subcontractors[key + 1]}
                                    viewType={"subList"}
                                  />
                                </td>}
                              {selectedInfo === "ACH" && selectedKey === key &&
                                <td colSpan={13} className="bg-white p-3">
                                  <div className="text-left pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => closeACHInsu()}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                  </div>
                                  <div className="text-center mt--4"><h3>{achType} ACH Information</h3></div>
                                  <AchInformation
                                    workflowTask={selectedCurrentTask}
                                    app={selectedApp}
                                    item={item}
                                    setViewBprmFormShowHide={setViewBprmFormShowHide}
                                    viewType={"subcontractorList"}
                                    achType={achType}
                                    setSelectedApp={setSelectedApp}
                                  />
                                </td>}
                              {selectedInfo === "Insurance" && selectedKey === key &&
                                <td colSpan={13} className="bg-white p-3">
                                  <div className="text-left pr-0">
                                    <button
                                      className="btn btn-sm btn-outline-default"
                                      onClick={() => closeACHInsu()}
                                    >
                                      <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                  </div>
                                  <div className="text-center mt--4"><h3>{insuranceType} Insurance Information</h3></div>
                                  <InsuranseInformation
                                    workflowTask={selectedCurrentTask}
                                    app={selectedApp}
                                    item={item}
                                    setViewBprmFormShowHide={setViewBprmFormShowHide}
                                    viewType={"subcontractorList"}
                                    insuranceType={insuranceType}
                                    setSelectedApp={setSelectedApp}
                                  />
                                </td>}
                            </tr>
                            {wfForm && selectedFormKey === key &&
                              <td colSpan={13} className="bg-white p-3">
                                <div className="text-left mb-3 pr-0">
                                  <button
                                    className="btn btn-sm btn-outline-default mb-4"
                                    onClick={() => handleViewSubcontractorForm(`${viewFormType}`, -1, null)}
                                  >
                                    <i className="fa fa-times mr-2"></i>Close
                                  </button>
                                </div>
                                <WorkflowElement
                                  wfTask={wfTask}
                                  wfForm={wfForm}
                                  handleNextTask={handleNextTask}
                                  viewType={true}
                                  appSummary={false}
                                  codeVerified={true}
                                  wfTaskType={"form"}
                                  // actionType={"workflow"}
                                  updatedStateData={updatedStateData}
                                />
                              </td>}
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {subcontractors.length === 0 && dataType === 'filter' && <span style={{ color: "#f5365c" }}>No Result Found</span>}
                  </div>
                  {selectedKey === -1 && selectedFormKey === -1 &&
                    <Pagination
                      currentPage={currentPage}
                      pageSize={pageSize}
                      itemsCount={rowsCount}
                      onPageChange={handlePageChange}
                      startIndex={startIndex}
                      endIndex={endIndex}
                    ></Pagination>
                  }
                </Tab.Content>
              </Tab>
              {type === "application" &&
                <Tab eventKey="addEditSubcontractor" title={`${selectedSubcontractorId === 0 ? "Add" : "Edit"} Subcontractor`}
                  tabClassName="page-tab border border-left-0 border-top-0">
                  <Tab.Content className="border p-3 border-top-0">
                    {selectedTab === "addEditSubcontractor" && <AddSubcontractor selectedObj={selectedObj}
                      handleAddEditSubcontractor={handleAddEditSubcontractor}
                      selectedTab={selectedTab}
                    />}
                  </Tab.Content>
                </Tab>}
              {type === "partner" &&
                <Tab eventKey="status" title="Activate/Deactivate" tabClassName="page-tab border border-left-0 border-top-0">
                  <Tab.Content className="border p-3 border-top-0">
                    {selectedSubcontractorId === 0 && <div className="">
                      <h2 className="text-danger mt-1"> Alert : Please select the Subcontractor first</h2>
                    </div>}

                    {selectedSubcontractorId > 0 &&
                      <ActiveDeactiveHistory selectedObj={selectedObj} type="partner" typeName="Subcontractor" actionType={actionType}
                        handlePermissionShowHide2={handlePermissionShowHide2} />}
                  </Tab.Content>
                </Tab>}
              {type === "partner" &&
                <Tab eventKey="users" title={<span onClick={handlePartnerPerformer}>Assign/Manage Users</span>}
                  tabClassName="page-tab border-0">
                  <Tab.Content className="border p-3 border-top-0">
                    {selectedSubcontractorId === 0 &&
                      <div className="col-md-12">
                        <h3 className="text-danger mt-1"> Alert : Please select the Subcontractor first</h3>
                      </div>
                    }
                  </Tab.Content>
                </Tab>}
            </Tabs>
          </div>
        </div>
      </div>


      {/* {showHide &&
        <AddSubcontractor
          showHide={showHide}
          handleModalShowHide={handleModalShowHide}
          selectedObj={selectedObj}
        //getFieldData={getFieldData}
        ></AddSubcontractor>} */}

      {/* {logShowHide &&
        <ActiveDeactiveHistory
          logShowHide={logShowHide}
          handleLogShowHide={handleLogShowHide}
          selectedObj={selectedObj}
          type="partner"
          pageType="Subcontractor"
          actionType={actionType}
        ></ActiveDeactiveHistory>} */}
      {remainderMsgShowHide &&
        <ReminderAlertMessage
          remainderMsgShowHide={remainderMsgShowHide}
          handleRemainderMessage={handleRemainderMessage}
        ></ReminderAlertMessage>}
    </React.Fragment>
  );
}

//export default ListSubcontractor;
